import { createGlobalState, tryOnScopeDispose, useDebounceFn } from '@vueuse/core';
import $ from 'jquery';
import UAParser from 'ua-parser-js';
import { reactive } from 'vue';

import { _commons, WEBAPP_TYPE } from '#public/commons-global';

const useIsUserAgentMobile = createGlobalState(() => {
    const userAgent = new UAParser().getResult();
    return (
        userAgent.device.type === 'mobile'
        || userAgent.device.type === 'tablet'
        || userAgent.device.type === 'wearable'
    );
});

export function useDisplayWidths() {
    const isUserAgentMobile = useIsUserAgentMobile();
    const fattapp2Application = __CUSTOM_WEB_APPLICATION__ === WEBAPP_TYPE.FATTAPP_V2;
    const _DISPLAY_WIDTHS = reactive({
        ..._commons.DISPLAY_WIDTHS,
        user: 0,
        userHeight: 0,
        userSizeAuto: 0,
        mobile: 768,
        isMobileView: isUserAgentMobile,
        isMobileFormsLayout: isUserAgentMobile,
        isMobileFormsLayoutFattapp: isUserAgentMobile && fattapp2Application,
        isUserAgentMobile,
    });

    function onResize() {
        const width1 = window.innerWidth;
        const width2 = document.documentElement.clientWidth;
        const height1 = window.innerHeight;
        const height2 = document.documentElement.clientHeight;
        // bug in manageFactures.shtml - on retina display it reports real pixels somehow
        // 572x3408 instead of computed css 393x852
        // this forces menu to go mobile layout
        const width = Math.min(width1, width2);
        const height = Math.min(height1, height2);
        const sizeAuto = Math.min(width, height);
        _DISPLAY_WIDTHS.user = width;
        _DISPLAY_WIDTHS.userHeight = height;
        _DISPLAY_WIDTHS.userSizeAuto = sizeAuto;
        if(!isUserAgentMobile) {
            // for mobile phone always mobile view
            _DISPLAY_WIDTHS.isMobileView = width < _DISPLAY_WIDTHS.mobile;
            _DISPLAY_WIDTHS.isMobileFormsLayout = width < _DISPLAY_WIDTHS.mobile;
            if(fattapp2Application) {
                _DISPLAY_WIDTHS.isMobileFormsLayoutFattapp = width < _DISPLAY_WIDTHS.mobile;
            }
        }
    }

    const debouncedOnResize = useDebounceFn(() => {
        onResize();
    }, 200, { maxWait: 200 });

    $(() => {
        $(window).on('resize', () => { debouncedOnResize(); });
    });

    tryOnScopeDispose(() => {
        $(window).off('resize', onResize);
    });

    onResize();

    return _DISPLAY_WIDTHS;
}
